import type { FC } from "react";
import React from "react";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";
import { AppQueryPopupsController } from "../AppQueryPopupsBloc";
import { GlpContinuationTasks } from "../../GlpContinuationTasks/GlpContinuationTasks";
import { useSearchParams } from "react-router-dom";
import translate from "src/lib/translate";

const GlpContinuationPopup: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();

  const [query] = useSearchParams();
  const title =
    query.get("title") ?? translate("glpContinuation.header.titlePlain");

  const onClose = () => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  };

  return (
    <InDialog
      hideHeader
      popup
      title={title}
      onClose={onClose}
      returnUrl={returnUrl}
      simple
    >
      <GlpContinuationTasks onClose={onClose} />
    </InDialog>
  );
};

export default GlpContinuationPopup;
